import type { ColorPickerProperties } from '../types';

export const isActive = (from: string, colorPickerProperties: ColorPickerProperties) =>
    colorPickerProperties.from === from;
